import React from 'react';
import { Button, Checkbox } from '@trackman/react-ui';
import styled, { css } from 'styled-components';
import { brand, grey, white } from 'styles/Colors';

const FontOswald = ({ size }: { size: string }) => css`
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: ${size};
`;

const FontLato = ({ size }: { size: string }) => css`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: ${size};
`;

const ButtonStyle = () => css`
  margin-top: 12px;
  margin-left: auto;
  margin-right: auto;
  min-width: 60px;
`;

export const MergeWrapper = styled.div`
  width: 80%;
  margin: auto;
  position: relative;

  .ReactTable {
    background-color: ${white};
  }

  .DayPickerInput input:focus {
    outline: none;
  }
  .team-loader {
    position: absolute;
    margin-top: 60px;
  }
`;

export const PageTitle = styled.h1`
  ${FontOswald({ size: '22px' })}
  line-height: 31px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  margin-bottom: 20px;
`;

export const PageSubtitle = styled.h2`
  ${FontOswald({ size: '18px' })}
  font-style: normal;
  line-height: 25px;
  text-transform: uppercase;
`;

export const MergeButton = styled((props) => <Button {...props} />)`
  ${ButtonStyle()}
`;

export const SearchButton = styled((props) => <Button {...props} />)`
  ${ButtonStyle()}
`;

export const VerifiedCheckbox = styled((props) => <Checkbox {...props} />)`
  .checkbox {
    background-color: ${brand} !important;
    color: ${brand} !important;
    cursor: default;
    margin-top: 17px;
    margin-left: 20px;
  }
`;
export const CancelButton = styled((props) => <Button {...props} />)`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export const TableDividerText = styled.span`
  ${FontLato({ size: '15px' })}

  line-height: 21px;
  margin-top: 30px;
  margin-bottom: 30px;
  display: block;
  text-align: center;
`;

export const MasterGameHeader = styled.div`
  background-color: ${white};
  border-radius: 5px;
  border: 1px solid ${grey};
  overflow: hidden;
`;

export const HeaderTitle = styled.span`
  ${FontOswald({ size: '18px' })}
  line-height: 25px;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 5px;
  text-transform: uppercase;
`;
export const HeaderContent = styled.span`
  ${FontLato({ size: '15px' })}

  line-height: 21px;
  padding-left: 20px;
  margin-bottom: 20px;
  display: block;
`;
export const HeaderDivider = styled.div`
  border-bottom: 1px solid #e0e0e0;
  height: 0px;
`;

export const MergePage = styled.div`
  position: relative;
`;
